import "./LinearLoader.css";
import React from "react";
import { LinearProgress } from "material-ui/Progress";

function LinearLoader(props) {
  return (
    <LinearProgress
      className="linear-loader"
      variant="query"
      color="secondary"
    />
  );
}

export default LinearLoader;



// WEBPACK FOOTER //
// ./src/components/LinearLoader/LinearLoader.js